export default "__VITE_ASSET__D$FhLFVG__"